<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    getReports (id) {
      this.$store.dispatch('getReports', id)
    },
    getStudent_tutors (id) {
      this.$store.dispatch('getStudent_tutors', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getReports(to.params.id)
      vm.getStudent_tutors(to.params.id)
    })
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Reports.vue?6be8ebc4